import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-section-wrapper',
  imports: [NgTemplateOutlet],
  template: `
    <div class="formly-section-wrapper" [class]="props.styleClass">
      <h3
        class="section-header"
        [class.with-content]="!!props.headerContentTemplate"
        [class.collapsible]="props.collapsible">
        <span class="section-title">{{ props.label }}</span>

        @if (props.headerContentTemplate) {
          <div class="section-header-content">
            <ng-container
              [ngTemplateOutlet]="props.headerContentTemplate"
              [ngTemplateOutletContext]="{ field: field }" />
          </div>
        }

        @if (props.collapsible) {
          <span class="section-toggle">
            <i
              class="clickable"
              [class.mynaui-chevron-down]="!field.props.collapsed"
              [class.mynaui-chevron-up]="field.props.collapsed"
              (click)="toggleCollapse()"></i>
          </span>
        }
      </h3>
      <div class="section-body" [class.collapsed]="field.props.collapsed">
        <ng-container #fieldComponent />
      </div>
    </div>
  `,
})
export class FormlySectionWrapperComponent extends FieldWrapper {
  toggleCollapse(): void {
    this.field.props.collapsed = !this.field.props.collapsed;
  }
}
